<script setup lang="ts">
const swiper = useSwiper()
</script>

<template>
	<div class="container">
		<div class="container__dot" :data-active="0 === swiper.realIndex"></div>
		<div class="container__dot" :data-active="1 === swiper.realIndex"></div>
		<div class="container__dot" :data-active="2 === swiper.realIndex"></div>
	</div>
</template>

<style scoped lang="scss" src="./SwiperDots.scss"></style>
